module.exports = __webpack_public_path__ + "img/yanxiuxueyuanlogo.0d89e106.png";